import * as React from 'react';

import { Button, ButtonThemeType, IStyleConfig } from '@cian/components';


interface IRevealContentProps {
  buttonLabel: React.ReactChild;
  buttonTheme: ButtonThemeType;
  buttonStyle?: IStyleConfig;
  hiddenContent: React.ReactNode;
  onRevealed?: () => void;
}

interface IRevealContentState {
  contentVisible: boolean;
}

export default class RevealContent extends React.Component<IRevealContentProps, IRevealContentState> {
  public constructor(props: IRevealContentProps) {
    super(props);
    this.state = {
      contentVisible: false,
    };
  }
  public render() {
    const { hiddenContent, buttonLabel, buttonTheme, buttonStyle } = this.props;
    return (
      this.state.contentVisible ?
        <div>
          {hiddenContent}
        </div>
        :
        <Button buttonStyle={buttonStyle} theme={buttonTheme} onClick={e => this.reveal()}>
          {buttonLabel}
        </Button>
    );
  }

  private reveal() {
    this.setState({contentVisible: true});
    if (this.props.onRevealed) {
      this.props.onRevealed();
    }
  }
}



// WEBPACK FOOTER //
// ./src/bundles/common/components/reveal_content/reveal_content.tsx